import { render } from "./OkrFilterSaver.vue?vue&type=template&id=0d884ce3&scoped=true"
import script from "./OkrFilterSaver.vue?vue&type=script&lang=js"
export * from "./OkrFilterSaver.vue?vue&type=script&lang=js"

import "./OkrFilterSaver.vue?vue&type=style&index=0&id=0d884ce3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d884ce3"]])

export default __exports__